import React from "react";

import DoNotMountComponent from "../DoNotMountComponent/DoNotMountComponent";
import SocialLink, { PropsSocialLink } from "./SocialLink/SocialLink";

interface PropsSocialsLinksList {
  socialLinkList: PropsSocialLink[];
  settings?: Partial<PropsSocialLink>;
}
const SocialLinksList: React.FC<PropsSocialsLinksList> = (
  props: PropsSocialsLinksList,
) => {
  if (!props.socialLinkList || !Array.isArray(props.socialLinkList))
    return <DoNotMountComponent sms={"No hay arrays con links"} log={props} />;
  const socialLinkList: PropsSocialLink[] = props.socialLinkList.map(
    (socialLink): PropsSocialLink => {
      return {
        url: socialLink.url,
        colorIcon: socialLink?.colorIcon || props.settings?.colorIcon || null,
        type: socialLink?.type || props.settings?.type || null,
        isDisable: socialLink?.isDisable || props.settings?.isDisable || null,
      };
    },
  );
  return (
    <ul className={"m-social-link-list"}>
      {socialLinkList.map((link: PropsSocialLink, index: number) => (
        <li key={index} className={"social-link-list__item"}>
          <SocialLink {...link} />
        </li>
      ))}
    </ul>
  );
};

export default SocialLinksList;
